/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './applyWrites.defs.js'
export { main as default } from './applyWrites.defs.js'
